import { render, staticRenderFns } from "./MainDifficulty.vue?vue&type=template&id=1dc69094&scoped=true&"
import script from "./MainDifficulty.vue?vue&type=script&lang=js&"
export * from "./MainDifficulty.vue?vue&type=script&lang=js&"
import style0 from "./MainDifficulty.vue?vue&type=style&index=0&id=1dc69094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc69094",
  null
  
)

export default component.exports